import { Action, createReducer, on } from '@ngrx/store';
import {
  getTransactionReceiptAction,
  getTransactionReceiptErrorAction,
  getTransactionReceiptSuccessAction,
} from './transaction-receipt.actions';
import { TransactionReceiptState } from './transaction-receipt.state';

const initialState = new TransactionReceiptState();

const reducer = createReducer(
  initialState,
  on(getTransactionReceiptAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getTransactionReceiptSuccessAction, (state, { transactionReceipt: transactionReceipt }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.transactionReceipt = transactionReceipt;
    return newState;
  }),
  on(getTransactionReceiptErrorAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    return newState;
  })
);

export function transactionReceiptReducer(state: TransactionReceiptState | null, action: Action) {
  return reducer(state, action);
}
